<app-modal-header (closeModal)="close()"></app-modal-header>
<app-modal-body>
  @defer (when interests) {
    <div class="row">
      <div class="col-12">
        <h1 class="mb-2 fw-medium fs-5">
          {{
            (isHasRecommendation || isHasMeetInterest || isHasIntendToMeet
              ? 'UPDATE_YOUR_INTERESTS'
              : 'TELL_USE_YOUR_INTERESTS'
            ) | translate
          }}
        </h1>
        <p class="mb-2">
          {{
            (isHasRecommendation || isHasMeetInterest || isHasIntendToMeet
              ? 'RESELECT_ATTRIBUTES_THAT_YOU_ARE_INTERESTED_IN'
              : 'SELECT_ATTRIBUTES_THAT_YOU_ARE_INTERESTED_IN'
            ) | translate
          }}
        </p>
      </div>
    </div>

    @if (general.length > 0 || products.length > 0) {
      <div class="container-recommendation">
        @if (general.length > 0) {
          <div class="row m-0">
            <p class="fw-medium text-center mb-2 mt-3">
              {{ 'GENERAL_INTERESTS' | translate }}
            </p>
            @for (item of general; track $index; let first = $first) {
              <div class="col-6 mb-2 text-truncate">
                <button
                  type="button"
                  (click)="showModalFilter(item)"
                  class="btn btn-primary w-100 rounded-4 text-truncate d-flex align-items-center justify-content-start"
                >
                  <span class="btn btn-sm btn-secondary rounded-3 d-inline me-1 fs-12px">
                    {{
                      selectedFilter
                        | countInterestsSelected
                          : { id: item.term_id, title: item.term_public, termType: item.term_type }
                    }}
                  </span>
                  <p class="mb-0 text-truncate">
                    {{ item.term_public }}
                  </p>
                </button>
              </div>
            }
          </div>
        }

        @if (products.length > 0) {
          <div class="row m-0 mt-3">
            <p class="fw-medium text-center mb-2">
              {{ 'PRODUCT_INTERESTS' | translate }}
            </p>
            @for (item of products; track $index; let first = $first) {
              <div class="col-6 mb-2">
                <button
                  type="button"
                  (click)="showModalFilter(item)"
                  class="btn btn-primary rounded-4 w-100 text-truncate d-flex align-items-center justify-content-start"
                >
                  <span class="btn btn-sm btn-secondary rounded-3 d-inline me-1 fs-12px">
                    {{
                      selectedFilter
                        | countInterestsSelected
                          : { id: item.term_id, title: item.term_public, termType: item.term_type }
                    }}
                  </span>
                  <p class="mb-0 text-truncate">
                    {{ item.term_public }}
                  </p>
                </button>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <p class="text-center fw-medium mt-4">{{ 'NO_DATA_AVAILABLE' | translate }}</p>
    }
  } @placeholder {
    @if (isShowPlaceholder) {
      <div class="d-flex flex-column gap-3 mt-5">
        @for (item of [].constructor(8); track $index) {
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '30px',
            }"
          />
        }
      </div>
    }
  }
</app-modal-body>
<app-modal-footer>
  @if (!hasNoInterestCategory) {
    <div class="d-flex justify-content-center w-100">
      <button
        type="button"
        class="btn btn-primary rounded-5 fw-medium"
        (click)="doUpdateInterests()"
        [disabled]="isHttpRequestRunning"
      >
        @if (isHttpRequestRunning) {
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        }
        {{ (isHasRecommendation || isHasMeetInterest || isHasIntendToMeet ? 'UPDATE' : 'SAVE') | translate }}
      </button>
    </div>
    @if (errorMessage()) {
      <div class="d-flex justify-content-center w-100">
        <span class="text-danger mt-2">{{ errorMessage() | translate }}</span>
      </div>
    }
  }
</app-modal-footer>
